export function accountLabelOf(code: string | null): string {
  if (code === '4.1.3') return '4.1.3 Comissões de profissionais';
  if (code === '4.1.7') return '4.1.7 Comissões fora da folha';
  if (code === '4.4.4') return '4.4.4 Comissões de autônomos e PJ';
  return 'Conta do plano a escolher com o contador';
}

const MONTH_NAMES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

export function monthLabel(month: string): string {
  const [year, number] = month.split('-').map(Number) as [number, number];
  return `${MONTH_NAMES[number - 1]!} de ${String(year)}`;
}

/// O mês atual e os 23 anteriores, do mais novo ao mais velho.
export function monthOptions(today: string) {
  const [year, month] = today.split('-').map(Number) as [number, number];
  return Array.from({ length: 24 }, (_, index) => {
    const date = new Date(Date.UTC(year, month - 1 - index, 1));
    const value = date.toISOString().slice(0, 7);
    return { value, label: monthLabel(value) };
  });
}
